import type { AuditLogResponse } from '@lens/shared';
import { apiRequest } from '../../shared/api/client.ts';

export async function getItemHistory(
  spaceId: string,
  itemId: string,
): Promise<AuditLogResponse> {
  return apiRequest<AuditLogResponse>(
    `/api/spaces/${spaceId}/items/${itemId}/history`,
    { method: 'GET' },
  );
}
